// This file is auto-generated by the `scripts/wallets/generate.ts` script.
// Do not modify this file manually.
export const wallet = {
    id: "co.lobstr",
    name: "LOBSTR Wallet",
    homepage: "https://lobstr.co/",
    image_id: "0dafcaab-0852-47f7-85dd-436b86491d00",
    app: {
        browser: "https://lobstr.co/",
        ios: "https://apps.apple.com/us/app/lobstr-stellar-wallet/id1404357892",
        android: "https://play.google.com/store/apps/details?id=com.lobstr.client",
        mac: null,
        windows: null,
        linux: null,
        chrome: null,
        firefox: null,
        safari: null,
        edge: null,
        opera: null,
    },
    rdns: null,
    mobile: {
        native: "lobstr://",
        universal: "https://lobstr.co/uni/wc",
    },
    desktop: {
        native: null,
        universal: null,
    },
};
//# sourceMappingURL=index.js.map